import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { AllEventsFragmentFragmentDoc } from '../fragments/allEventsFragement.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventForDownloadsQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;


export type EventForDownloadsQuery = { __typename?: 'Query', event?: { __typename?: 'Event', id: string, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, event_participants?: Array<{ __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null, item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event?: { __typename?: 'EventReduced', id?: string | null, name?: string | null } | null }> | null, authorized_signers: Array<{ __typename?: 'AuthorizedSigner', id: string, name: string, event_account_id: string, event_account_name: string, allowed_item_locations?: Array<{ __typename?: 'ItemLocation', id: string, name: string, event_id?: string | null }> | null }> }> | null } | null };


export const EventForDownloadsDocument = gql`
    query eventForDownloads($eventId: ID!) {
  event(id: $eventId) {
    ...allEventsFragment
  }
}
    ${AllEventsFragmentFragmentDoc}`;

/**
 * __useEventForDownloadsQuery__
 *
 * To run a query within a React component, call `useEventForDownloadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventForDownloadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventForDownloadsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventForDownloadsQuery(baseOptions: Apollo.QueryHookOptions<EventForDownloadsQuery, EventForDownloadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventForDownloadsQuery, EventForDownloadsQueryVariables>(EventForDownloadsDocument, options);
      }
export function useEventForDownloadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventForDownloadsQuery, EventForDownloadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventForDownloadsQuery, EventForDownloadsQueryVariables>(EventForDownloadsDocument, options);
        }
export type EventForDownloadsQueryHookResult = ReturnType<typeof useEventForDownloadsQuery>;
export type EventForDownloadsLazyQueryHookResult = ReturnType<typeof useEventForDownloadsLazyQuery>;
export type EventForDownloadsQueryResult = Apollo.QueryResult<EventForDownloadsQuery, EventForDownloadsQueryVariables>;